import ContactAccordion from 'src/components/HelpInfo/ContactAccordion';
import AccordionList from 'src/components/HelpInfo/AccordionList';

const ReviewHelpInfo = () => {
  return <AccordionList accordions={[<ContactAccordion key="contactAccordion" />]} />;
};

export default ReviewHelpInfo;
